import '../styles/TheSteps.css';

const STEPS = [
  {
    icon: '/images/detect.avif',
    title: '1. Detect',
    body: 'Botzo reads charts, headlines and feeds at the same time, looking for the same story showing up in more than one place.',
  },
  {
    icon: '/images/score.avif',
    title: '2. Score',
    body: "Each narrative gets a confidence number. Most never clear the bar, and the ones that don't are logged anyway.",
  },
  {
    icon: '/images/launch.avif',
    title: '3. Launch',
    body: 'Clear the threshold and the token goes live on Solana on its own, with the sources that triggered it attached.',
  },
];

/**
 * Sits after <StepsSection /> in App.jsx. Uses the same "section-cover"
 * treatment as TheComeback/StepsSection — see ScrollSections.css.
 */
export default function TheSteps({ zIndex = 4 }) {
  return (
    <section id="the-steps" className="the-steps section-cover" style={{ zIndex }}>
      <p className="the-steps__eyebrow">( THE STEPS )</p>
      <h2 className="the-steps__title">How A Post Becomes A Market.</h2>

      <div className="the-steps__grid">
        {STEPS.map((step) => (
          <div className="the-steps__item" key={step.title}>
            <img className="the-steps__icon" src={step.icon} alt="" />
            <h3 className="the-steps__item-title">{step.title}</h3>
            <p className="the-steps__item-body">{step.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}